import { apiFetch } from "@/lib/api";
import type { CatalogData, CatalogRow, CatalogState } from "@/lib/catalog";
import type { Crop } from "@/lib/postPlan";
import type { EnhanceOutcome } from "@/lib/verdict";
import { post } from "@/lib/trends";

export const loadCatalog = () => apiFetch<CatalogData>("/api/catalog");

export const startPick = (body: { dress_ids?: number[]; redo: boolean }) =>
  post<{ started: boolean }>("/api/catalog/pick", body);

export const patchPair = (
  dressId: number,
  body: { reference_item_id?: number; face_id?: number; state?: CatalogState },
) => apiFetch<CatalogRow>(`/api/catalog/${dressId}`, { method: "PATCH", body: JSON.stringify(body) });

export const nextRef = (dressId: number) => post<CatalogRow>(`/api/catalog/${dressId}/next`, {});

export const markLaunched = (dressId: number, generationId: number) =>
  post<CatalogRow>(`/api/catalog/${dressId}/launched`, { generation_id: generationId });

/** Метка варианта генерации каталога (№447): «Брак» — `rejected` (повтор снимает), «Удачная» — `picked` с рамкой 3:4
 * (улучшение пойдёт по ней; `null` — весь кадр), «Снять утверждение» — `none`: явное снятие, не переключатель. */
export const pickVariant = (variantId: number, status: "picked" | "rejected" | "none", crop: Crop | null = null) =>
  post<{ enhance: EnhanceOutcome }>(`/api/results/variants/${variantId}/pick`, crop ? { status, crop } : { status });
